import React, { memo } from "react";
import { Text } from "components/common/Text";

export type QuarterBoxProps = {
  title: string;
  home: number;
  away: number;
  className?: string;
};

const classNames = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(" ");

export const QuarterBox: React.FC<QuarterBoxProps> = memo(
  ({ title, home, away, className }) => {
    return (
      <div
        className={classNames(
          "flex flex-col items-center justify-center rounded-[0.5vw] border p-[1vw] bg-darkestBlue border-border",
          className
        )}
        aria-label={`Period ${title} score`}
      >
        <Text
          variant="chartTitle"
          className="mb-[0.5vw] font-bold text-statisticTitle"
        >
          {title}
        </Text>
        <Text variant="chartValue" className="flex items-center gap-[1vw]">
          <span>{home}</span>
          <span className="opacity-60" aria-hidden>
            -
          </span>
          <span>{away}</span>
        </Text>
      </div>
    );
  }
);

export default QuarterBox;
